import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  JbAutocompleteModule,
  JbCheckboxModule,
  JbFormFieldContainerModule,
  JbInputModule,
  JbRadioModule,
  JbSelectModule,
  JbSrOnlyModule,
} from 'jb-component-library';

import { UIModule } from '../ui';
import { FormWrapperComponent } from './form-wrapper.component';

const MODULES = [
  CommonModule,
  UIModule,
  FormsModule,
  ReactiveFormsModule,
  JbInputModule,
  JbCheckboxModule,
  JbSelectModule,
  JbRadioModule,
  JbAutocompleteModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
];

const DECLARATIONS = [FormWrapperComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class JbFormWrapperModule {}
